import { DemoStep } from 'plume-ui/dist/components/Demo/Demo';
import i18n from '../../utils/i18n';

export enum DemoId {
  None = '',
  AutonomousMonitors = 'autonomous-monitors',
}

const getSteps = (
  t: typeof i18n.t,
): Record<DemoId, DemoStep[] | undefined> => ({
  [DemoId.None]: undefined,
  [DemoId.AutonomousMonitors]: [
    {
      name: 'autonomous-monitors-step1',
      content: t('monitors.autonomous.demo.step1'),
      targetId: '.FlatTabs__Toggler-selected',
      delay: 1000,
    },
    {
      name: 'autonomous-monitors-step2',
      content: t('monitors.autonomous.demo.step2'),
      targetId: '.AutonomousMonitorCell__notifications',
    },
    {
      name: 'autonomous-monitors-step3',
      content: t('monitors.autonomous.demo.step3'),
      targetId: '.AutonomousMonitorCell__header .Tooltip:nth-of-type(2)',
    },
    {
      name: 'autonomous-monitors-step4',
      content: t('monitors.autonomous.demo.step4'),
      targetId: '.AutonomousMonitorCell__tableContainer',
    },
    {
      name: 'autonomous-monitors-step5',
      content: t('monitors.autonomous.demo.step5'),
      targetId: '.AutonomousMonitorCell__headerIcons .Dropdown',
    },
  ],
});

export default getSteps;
